<script lang="ts">
	import { afterNavigate, goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { CourseBySlugStore } from '$houdini';
	import FeaturedHighlights from '$lib/components/Auth/SignUp/highlights/FeaturedHighlights.svelte';
	import SignUp from '$lib/components/Auth/SignUp/SignUp.svelte';
	import { LOGIN_MISSING_META, SIGN_UP_STEP, SIGN_UP_URL } from '$lib/constants';
	import { redirectBySearchParams } from '$lib/service/navigation';
	import { getTranslate } from '@tolgee/svelte';
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';

	const { t } = getTranslate();
	// Construct the tolgee key array for general platform highlights.
	const generalPlatformHighlights: Array<string> = Array.from({ length: 4 }, (_, i) =>
		$t(`generalPlatformSignUp.platformHighlight_${i}`)
	);

	const courseStore: CourseBySlugStore = new CourseBySlugStore();
	$: courseData = $courseStore.data?.course;
	$: isFeaturedLink = !!courseData;
	$: title = isFeaturedLink ? courseData?.name : $t('generalPlatformSignUp.title');

	afterNavigate(async ({ from }) => {
		const course = $page.url.searchParams.get('course');
		const url =
			from && !from.url.href.includes('access_token') && !from.url.href.includes('/auth/login')
				? from.url.href
				: course
				? `/courses/${course}`
				: undefined;
		if (!courseData && !!localStorage.getItem(SIGN_UP_URL)?.includes('courses')) {
			const slug = localStorage.getItem(SIGN_UP_URL)?.split('courses/')[1]?.split('/')[0];
			if (slug) {
				await courseStore.fetch({
					variables: {
						slug
					}
				});
			}
		}
		if (url) {
			localStorage.setItem(SIGN_UP_URL, url);
		}
	});

	function handleSignUp() {
		setTimeout(() => {
			const courseToRedirectTo = localStorage.getItem(SIGN_UP_URL);
			if (courseToRedirectTo) {
				goto(
					courseToRedirectTo.startsWith('http') ? new URL(courseToRedirectTo) : courseToRedirectTo
				);
				localStorage.removeItem(SIGN_UP_URL);
				localStorage.removeItem(SIGN_UP_STEP);
				localStorage.removeItem(LOGIN_MISSING_META);
			} else {
				localStorage.removeItem(SIGN_UP_STEP);
				localStorage.removeItem(LOGIN_MISSING_META);

				redirectBySearchParams($page.url, '/');
			}
		}, 1200);
	}

	function handleError(event: any) {
		console.log('handleError', event);
		alert('error');
	}

	onMount(() => {
		const url = $page.url;
		const slug =
			url.searchParams.get('course') ||
			url.searchParams.get('redirect')?.split('courses/')?.[1]?.split('/')?.[0];
		if (slug) {
			courseStore.fetch({
				variables: {
					slug
				}
			});
		}
	});
</script>

<div class="vert-center">
	<div class="flex-1 flex">
		<FeaturedHighlights
			title={title ?? ''}
			thumbnail={courseData?.featuredThumbnail}
			highlights={courseData?.keyTakeaways ? courseData?.keyTakeaways : generalPlatformHighlights}
		/>
		<SignUp
			additionalClass="flex-1 w-1/2 vert-center x-container"
			on:success={() => handleSignUp()}
			on:error={handleError}
		/>
	</div>
</div>
